
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

const SubscriptionForm = ({ className = "" }: { className?: string }) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      toast.error("Please enter a valid email address");
      return;
    }
    
    setIsLoading(true);
    
    try {
      const { data, error } = await supabase.functions.invoke("subscribe", {
        body: { email },
      });

      if (error) {
        throw error;
      }
      
      toast.success(data.message || "Successfully subscribed!");
      setEmail("");
    } catch (error: any) {
      console.error("Subscription error:", error);
      
      if (error.message?.includes("already subscribed")) {
        toast.info("You're already subscribed!");
      } else {
        toast.error("Failed to subscribe. Please try again later.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={`subscription-form ${className}`}>
      <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <Input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full"
            disabled={isLoading}
            required
          />
        </div>
        <Button 
          type="submit"
          disabled={isLoading} 
          className="bg-blog-neon hover:bg-blog-neon/90"
        >
          {isLoading ? (
            <>
              <span className="h-4 w-4 mr-2 animate-spin rounded-full border-2 border-t-transparent"></span>
              Subscribing...
            </>
          ) : (
            "Subscribe"
          )}
        </Button>
      </form>
    </div>
  );
};

export default SubscriptionForm;
